import { toast } from '@common/ui/general/Toast';
import mentor from '~referral/api/mentor';

const BASE_NAME = 'referral/mentor';

const ELIGIBILITY_INIT = `${BASE_NAME}/ELEGIBILITY_INIT`;
const ELIGIBILITY_SUCCESS = `${BASE_NAME}/ELEGIBILITY_SUCCESS`;
const ELIGIBILITY_ERROR = `${BASE_NAME}/ELEGIBILITY_ERROR`;

export function isMentorEligible() {
  return async dispatch => {
    dispatch({ type: ELIGIBILITY_INIT });
    const ELIGIBLE = 'is_eligible';
    try {
      const json = await mentor.getEligibleData();
      dispatch({
        type: ELIGIBILITY_SUCCESS,
        paylod: json?.[ELIGIBLE],
      });
    } catch (error) {
      toast.show({
        message: 'error',
        type: 'error',
      });
      dispatch({ type: ELIGIBILITY_ERROR, payload: error });
    }
  };
}

const initialState = {
  isLoading: false,
  isEligible: false,
  error: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case ELIGIBILITY_INIT:
      return {
        ...state, isLoading: true,
      };
    case ELIGIBILITY_SUCCESS:
      return {
        ...state, isLoading: false, isEligible: action.paylod,
      };
    case ELIGIBILITY_ERROR:
      return {
        ...state, error: action.payload, isLoading: false,
      };
    default:
      return state;
  }
}
